export const checkIsUserOwner = (userInfo, owners) => owners.some(({ id }) => id === userInfo?.id);
